<template>
  <div @click="hideMe" class="menu-overlay has-background-primary is-vertical-center" v-show="visible">
    <div class="m-r-lg m-l-lg has-text-centered is-fullwidth">
      <img src="@/../static/icons/play.png" class="is-xlarge icon m-r-md m-l-md m-b-md">
      <img src="@/../static/icons/stop.png" @click="$emit('stop')" class="is-xlarge icon m-r-md m-l-md m-b-md">
      <img src="@/../static/icons/save.png" @click="$emit('save')" class="is-xlarge icon m-r-md m-l-md m-b-md">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: ['show'],
  data () {
    return {
      visible: this.show
    }
  },
  methods: {
    showMe() {
      this.visible = true
    },
    hideMe() {
      this.visible = false
      this.$emit('hide')
    }
  }
}
</script>

<style>
.menu-overlay {
  position:fixed;
  top:0;
  right:0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.close-icon {
  opacity:0.7;
  position:absolute;
  top:1rem;
  right:0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Settings/WorkoutMenu.vue